import { Flex, Grid, SimpleGrid, Spinner, Text } from '@chakra-ui/react'
import { Input } from '../../../../components/Form/Input'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { Button } from '../../../../components/Button'
import { FaPlusCircle } from 'react-icons/fa'
import { IoIosRemoveCircle } from 'react-icons/io'
import { InputMaskForm } from '../../../../components/Form/InputMaskForm'
import { api } from '../../../../services/api'
import { useMutation, useQueryClient } from 'react-query'

async function onDelete(data) {
  const response = await api.delete(`/orcamento-pedido/deletar-cliente/`, {
    data,
  })

  return response.data
}

export function ListaContato({ idParceiro, dataClient }) {
  const {
    formState: { errors },
  } = useFormContext()
  const { fields, append, remove } = useFieldArray({
    name: 'contatos',
  })

  return (
    <Flex flexDir="column">
      <Text fontSize="12px" fontWeight="semibold" textAlign="center" py={'6px'} bg="#F5F5F5">
        Lista de Contatos
      </Text>
      <SimpleGrid columns={1} gap={2} p={1}>
        <Grid
          templateColumns={'1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 50px'}
          gap={2}
          p={1}
          bg="#F5F5F5"
          px={2}
          fontSize="12px"
          textTransform="uppercase"
          fontWeight="bold"
        >
          <Flex alignItems="end" gap={2}>
            <Text fontSize="12px">Nome</Text>
          </Flex>
          <Flex alignItems="end" gap={2}>
            <Text fontSize="12px">Telefone</Text>
          </Flex>
          <Flex alignItems="end" gap={2}>
            <Text fontSize="12px">Celular</Text>
          </Flex>
          <Flex alignItems="end" gap={2}>
            <Text fontSize="12px">Email</Text>
          </Flex>
          <Flex alignItems="end" gap={2}>
            <Text fontSize="12px">Departamento</Text>
          </Flex>
          <Flex alignItems="end" gap={2}>
            <Text fontSize="12px">Cargo</Text>
          </Flex>
          <Flex alignItems="end" gap={2}>
            <Text fontSize="12px">Apelido</Text>
          </Flex>
          <Flex alignItems="end" gap={2}>
            <Text fontSize="12px">Data Nascimento</Text>
          </Flex>
          <Flex alignItems="end" gap={2}></Flex>
        </Grid>

        <Grid templateColumns={'1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 50px'} gap={2} p={1} maxH="200px" overflowY="auto">
          {fields?.map((field, index) => (
            <Contato key={field.id_contato} field={field} index={index} idParceiro={idParceiro} remove={remove} dataClient={dataClient} />
          ))}
        </Grid>

        {errors?.contatos && (
          <Text fontSize="12px" color="red.500" textAlign="center" py={'6px'} bg="#F5F5F5">
            {errors.contatos.message}
          </Text>
        )}

        <Button
          ml="auto"
          leftIcon={<FaPlusCircle size={20} />}
          onClick={() =>
            append({
              nome: '',
              telefone: '',
              email: '',
              celular: '',
              cargo: '',
              departamento: '',
              apelido: '',
              data_nascimento: null,
            })
          }
        >
          Adicionar novo Contato
        </Button>
      </SimpleGrid>
    </Flex>
  )
}

const Contato = ({ index, field, idParceiro, remove, dataClient }) => {
  const { register, formState, control } = useFormContext()
  const queryClient = useQueryClient()

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: onDelete,
    onSuccess: (data) => {
      queryClient.setQueryData(['clientes', { busca: dataClient?.busca }], (oldData) => {
        const newData = oldData.pages.map((page) => {
          return {
            ...page,
            data: page.data.map((cliente) => {
              if (cliente.id_parceiro === idParceiro) {
                return {
                  ...cliente,
                  contatos: cliente.contatos.filter((contato) => contato.id_contato !== data.id_contato),
                }
              }

              return cliente
            }),
          }
        })

        return {
          ...oldData,
          pages: newData,
        }
      })
    },
  })

  async function handleDelete(data, index) {
    if (!data.id_contato) return remove(index)

    const param = {
      ...data,
      id_parceiro: idParceiro,
    }

    await mutateAsync(param)
  }

  return (
    <>
      <Flex alignItems="end" gap={2}>
        <Input width="100%" {...register(`contatos.${index}.nome`)} error={formState.errors?.contatos?.[index]?.nome} />
      </Flex>
      <Flex alignItems="end" gap={2}>
        <InputMaskForm
          maskChar=""
          mask=""
          control={control}
          name={`contatos.${index}.telefone`}
          error={formState.errors?.contatos?.[index]?.telefone}
        />
      </Flex>

      <Flex alignItems="end" gap={2}>
        <InputMaskForm
          maskChar=""
          mask=""
          control={control}
          name={`contatos.${index}.celular`}
          error={formState.errors?.contatos?.[index]?.celular}
        />
      </Flex>
      <Flex alignItems="end" gap={2}>
        <Input width="100%" {...register(`contatos.${index}.email`)} error={formState.errors?.contatos?.[index]?.email} />
      </Flex>
      <Flex alignItems="end" gap={2}>
        <Input width="100%" {...register(`contatos.${index}.departamento`)} error={formState.errors?.contatos?.[index]?.departamento} />
      </Flex>
      <Flex alignItems="end" gap={2}>
        <Input width="100%" {...register(`contatos.${index}.cargo`)} error={formState.errors?.contatos?.[index]?.cargo} />
      </Flex>
      <Flex alignItems="end" gap={2}>
        <Input width="100%" {...register(`contatos.${index}.apelido`)} error={formState.errors?.contatos?.[index]?.apelido} placeholder="Apelido" />
      </Flex>
      <Flex alignItems="end" gap={2}>
        <Input
          width="100%"
          type="date"
          {...register(`contatos.${index}.data_nascimento`)}
          error={formState.errors?.contatos?.[index]?.data_nascimento}
        />
      </Flex>

      <Flex alignItems="end" gap={2}>
        <Button
          bgColor="#FF0000"
          onClick={() => handleDelete({ id_contato: field.id_contato }, index)}
          size="sm"
          variant="ghost"
          isLoading={isLoading}
        >
          {!isLoading ? <IoIosRemoveCircle size={20} /> : <Spinner size="sm" />}
        </Button>
      </Flex>
      <input type="hidden" {...register(`contatos.${index}.id_contato`)} />
    </>
  )
}
